<div class="panel">
  <header class="panel__header">COTAÇÃO DO DIA</header>

  @if (vm$ | async; as vm) {
    <main class="panel__content">
      @if (vm.error) {
        <p class="panel__error" role="alert">{{ vm.error }}</p>
      }

      <div class="panel__columns">
        <section class="panel__column" aria-label="Cotação Real">
          <div class="panel__label">
            <img class="panel__flag-image" src="assets/flags/br.png" alt="Bandeira do Brasil" />
            <span class="panel__label-text">1 REAL<br />(BRL)</span>
          </div>
          <div class="panel__rate">
            <img class="panel__flag-image panel__flag-image--small" src="assets/flags/py.png" alt="Bandeira do Paraguai" />
            <span class="panel__currency">₲</span>
            <span class="panel__amount">{{ vm.brl }}</span>
          </div>
        </section>

        <section class="panel__column" aria-label="Cotação Dólar">
          <div class="panel__label">
            <img class="panel__flag-image" src="assets/flags/us.png" alt="Bandeira dos Estados Unidos" />
            <span class="panel__label-text">1 DOLAR<br />(USD)</span>
          </div>
          <div class="panel__rate">
            <img class="panel__flag-image panel__flag-image--small" src="assets/flags/py.png" alt="Bandeira do Paraguai" />
            <span class="panel__currency">₲</span>
            <span class="panel__amount">{{ vm.usd }}</span>
          </div>
        </section>
      </div>
    </main>

    <footer class="panel__footer">
      @if (vm.updatedAt) {
        <p class="panel__meta">Atualizado: {{ vm.updatedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</p>
      }
      <p class="panel__footer-note">*Cotações sujeitas a alteração</p>
    </footer>
  } @else {
    <footer class="panel__footer">
      <p class="panel__footer-note">*Cotações sujeitas a alteração</p>
    </footer>
  }
</div>
